/**
 * @fileoverview Centralized constants for the Visuals domain.
 *
 * Defines image style presets and shot types for AI image generation.
 */

/**
 * Pre-defined artistic styles for character image generation.
 */
export const CHARACTER_IMAGE_STYLES = [
    { value: 'photorealistic', label: 'Photorealistic', description: 'A highly detailed, realistic image that resembles a photograph.' },
    { value: 'fantasy-art', label: 'Fantasy Art', description: 'A painterly style with epic and magical elements, often seen in fantasy book covers.' },
    { value: 'comic-book', label: 'Comic Book', description: 'Bold lines, dynamic shading, and a graphic novel aesthetic.' },
    { value: 'anime', label: 'Anime / Manga', description: 'Classic Japanese animation style with distinct facial features and vibrant colors.' },
    { value: 'watercolor', label: 'Watercolor', description: 'Soft, flowing colors with a traditional, artistic feel.' },
    { value: 'film-noir', label: 'Film Noir', description: 'High-contrast black and white, dramatic shadows, and a moody, mysterious atmosphere.' },
    { value: 'cyberpunk', label: 'Cyberpunk', description: 'Neon lighting, futuristic technology, and a gritty, high-tech aesthetic.' },
    { value: 'pencil-sketch', label: 'Pencil Sketch', description: 'A hand-drawn graphite look with expressive linework, cross-hatching, and soft shading on paper.' },
] as const;

/**
 * Pre-defined shot types for character image generation.
 */
export const CHARACTER_IMAGE_SHOT_TYPES = [
    { value: 'portrait', label: 'Portrait', description: 'A close-up shot focusing on the character\'s face and shoulders.' },
    { value: 'half-body', label: 'Half-Body Shot', description: 'A shot framing the character from the waist up.' },
    { value: 'full-body', label: 'Full-Body Shot', description: 'A shot showing the character from head to toe, including their full attire.' },
    { value: 'action-shot', label: 'Action Shot', description: 'A dynamic shot capturing the character in motion.' },
] as const;
